import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCourseStore } from '../store/CourseStore'
import { useMetaStore } from '../store/MetaStore'
import LeaderboardView from '../views/LeaderboardView'

const LeaderboardController = () => {
  const validateLogin = useMetaStore((state) => state.validateLogin)
  const [rounds, setRounds] = useState([])
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const queryEventId = searchParams.get('eventId')
  const storeEventId = useMetaStore((state) => state.eventId)
  const eventId = queryEventId || storeEventId
  const setPageTitle = useMetaStore((state) => state.setPageTitle)
  const setCourse = useCourseStore((state) => state.setCourse)

  const [isFinalized, setIsFinalized] = useState(false)
  const [eventDate, setEventDate] = useState(null)

  useEffect(() => {
    if (!validateLogin()) {
      useMetaStore.getState().setErrorMsg('Login validation failed')
      console.error('Login validation failed')
      if (eventId) {
        navigate('/event/signin?eventId=' + eventId)
      } else {
        navigate('/error')
      }
    } else {
      setPageTitle('Leaderboard')
      fetchData()
    }
  }, [eventId])

  const fetchData = async () => {
    try {
      const golfersResp = await axios.get(`/gskapi/rounds/byevent/${eventId}`)
      setRounds(golfersResp.data)

      const eventResp = await axios.get(`/gskapi/event/find/${eventId}`)
      if (eventResp.data && eventResp.data.finalized) {
        setIsFinalized(true)
      } else {
        setIsFinalized(false)
      }
      setEventDate(eventResp.data?.eventDate)

      const courseResp = await axios.get(`/gskapi/courses/find/${eventResp.data.courseId}`)
      setCourse(courseResp.data)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  return (
    <div>
      <LeaderboardView sortedRounds={rounds} isFinalized={isFinalized} eventDate={eventDate} />
    </div>
  )
}

export default LeaderboardController
